import { toast } from "react-toastify";

export const saveAddressToClipboard = async (address: {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  zip: string;
  countryName: string;
  phone?: string | number;
  description?: string;
}) => {
  try {
    const formattedAddress = `${address.addressLine1}, ${address.addressLine2 ? address.addressLine2 + ", " : ""}${address.city}, ${address.state} ${address.zip}, ${address.countryName}${address.phone ? ", Phone: " + address.phone : ""}`;
    await navigator.clipboard.writeText(formattedAddress);
    toast.success("Address copied to clipboard", {
      position: "bottom-left",
    });
  } catch (err) {
    console.error("Failed to copy:", err);
  }
};
